import { ReduxState } from '../../../AppLoader/types';

const selectWhitelistFormRecentDownloads = (state: ReduxState) =>
  state.app.whitelistRequestForm.recentDownloads;
const selectWhitelistFormClaimantsList = (state: ReduxState) =>
  state.app.whitelistRequestForm.claimantsList;

// In safari and iPhone browsers, the string format is not a compatible date ISO format.
// Converting the empty space between the date and time to a `T` converts the string to an ISO compatible format
const getIsoDateFromString = (date) =>
  new Date(date.replace(' ', 'T')).getTime();

const sortByDate = (a, b) =>
  getIsoDateFromString(b.dateLastAccessed) -
  getIsoDateFromString(a.dateLastAccessed);

export const selectSortedWhitelistFormRecentDownloads = (state: ReduxState) => {
  const recentDownloads = selectWhitelistFormRecentDownloads(state);

  return recentDownloads.sort(sortByDate);
};

export const selectSortedWhitelistFormClaimantsList = (state: ReduxState) => {
  const claimantsList = selectWhitelistFormClaimantsList(state);

  return claimantsList.sort();
};
